import { useEffect } from "react";
import { logger } from "@/utils/logger";
import { RaisyLogoLoader } from "./RaisyLogoLoader";

// Mirrors the public routes registered in CRM.tsx's `<CustomRoutes noLayout>`
// block ("Public pages (no auth required)"). ra-core's requireAuth flag is
// admin-wide, not route-scoped: CoreAdminRoutes runs its auth check and shows
// this loader on every mount, including on these already-public, already-
// rendering routes — producing a full-screen overlay flash on top of content
// that doesn't need auth at all. Skip the overlay there instead.
const PUBLIC_PATH_PREFIXES = [
  "/landing",
  "/about",
  "/telephony",
  "/compare",
  "/blog",
  "/pitch",
  "/privacy_policy",
  "/terms_of_service",
];

function isPublicPath(pathname: string): boolean {
  if (pathname === "/") return true;
  return PUBLIC_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

/**
 * Minimal Raisy loading screen.
 *
 * Uses a custom logo-shaped loader: a Reuleaux-style diamond that traces the
 * outline of the Raisy logo. No text, no extra elements.
 */
export function RaisyLoadingPage() {
  const pathname = window.location.pathname;
  const isPublic = isPublicPath(pathname);

  useEffect(() => {
    logger.info("[LOADING][RaisyLoadingPage_005] mount check", { pathname, isPublic });
    if (isPublic) return;
    logger.info("[LOADING][RaisyLoadingPage_010] animation started");
    return () => {
      logger.info("[LOADING][RaisyLoadingPage_100] animation ended");
    };
  }, [pathname, isPublic]);

  if (isPublic) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black">
      <RaisyLogoLoader size={72} color="#0ab3bf" speed={1.17} stroke={5} strokeLength={0.2} bgOpacity={0.15} />
    </div>
  );
}
